import { User } from "@/data/entities/user";
import {createContext, useContext} from "react";

type AuthStateContextType = {
    user: User | null;
    setUser: (user: User | null) => void;
};

export const AuthStateContext = createContext<AuthStateContextType | null>(null);

const useAuthState = () => {
    const context = useContext(AuthStateContext);

    if (context === null) {
        throw new Error(
            "useAuthState must be used inside AuthStateProvider"
        );
    }

    return context;
};

export default useAuthState;